import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import { getIcon } from '../../data/iconMap';
import { CATEGORIES, CATEGORY_ORDER, categoryUrl } from '../../data/categories';

/**
 * Mobile accordion navigation mirroring the desktop mega menu.
 */
export default function MobileNav({ onNavigate }) {
  const [openKey, setOpenKey] = useState(null);
  return (
    <div className="flex flex-col divide-y divide-white/5" data-testid="mobile-mega-nav">
      {CATEGORY_ORDER.map((key) => {
        const cat = CATEGORIES[key];
        const expanded = openKey === key;
        const HeroIcon = getIcon(cat.icon);
        return (
          <div key={key} className="py-1">
            <div className="flex items-center justify-between">
              <Link
                to={categoryUrl(cat.slug)}
                onClick={onNavigate}
                className="flex items-center gap-3 py-3 text-white hover:text-gold transition-colors flex-1"
                data-testid={`mobile-nav-${cat.slug}`}
              >
                <HeroIcon size={18} className="text-gold" />
                <span className="text-sm uppercase tracking-[0.2em]">{cat.title}</span>
              </Link>
              <button
                type="button"
                onClick={() => setOpenKey(expanded ? null : key)}
                className="p-2 text-white/60 hover:text-white"
                aria-label={`Toggle ${cat.title} subcategories`}
                data-testid={`mobile-nav-toggle-${cat.slug}`}
              >
                <ChevronDown
                  size={16}
                  className={`transition-transform ${expanded ? 'rotate-180' : ''}`}
                />
              </button>
            </div>
            {expanded && (
              <div className="pl-9 pb-3 flex flex-col gap-2.5">
                {cat.subcategories.map((sub) => {
                  const href = sub.external ? sub.slug : categoryUrl(cat.slug, sub.slug);
                  return (
                    <Link
                      key={sub.slug}
                      to={href}
                      onClick={onNavigate}
                      className="text-xs text-white/70 hover:text-gold transition-colors"
                      data-testid={`mobile-sub-${cat.slug}-${sub.slug.replace(/\//g, '-')}`}
                    >
                      {sub.name}
                    </Link>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
